import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { closeActionDialog } from "../store/orderSlice";
import Select from "react-select";
import DropZone from "../../../share-components/upload/dropzone";
import Typography from "@material-ui/core/Typography";
import { baseUrlAsync } from "../../../utils/api";

export default function OrderActionForm(props) {
  const {
    dialog,
    size = "lg",
    closeDialog,
    isUseSelector,
    title,
    handleSubmit,
    orderState,
    submitBtnSaveRef,
    handleFileInputChange,
    onSubmitForm,
    customStyles,
    setValue,
    trigger,
    uploadFile,
    saveBtnLoad,
  } = props;

  // const addEditDialog = isUseSelector ? dialog : useSelector(dialog);
  const dispatch = useDispatch();
  // const [uploadFile, setUploadFile] = useState(null);

  const formatErrorMessage = (errorsArray) => {
    const orderNumbers = [...new Set(errorsArray.errors.map((err) => err.split(" ")[0]))];
    return errorsArray.error_type === 3
      ? `Orders  [${orderNumbers.join(", ")}]  are not found`
      : `Invoice  [${orderNumbers.join(", ")}]  are not found`;
  };

  const closeModalDialog = () => {
    dispatch(closeActionDialog());
  };

  return (
    <div className="flex flex-col modal-lg">
      <Modal size={size} {...orderState.actionDialog.props} toggle={() => closeModalDialog()}>
        <ModalHeader
          toggle={() => {
            closeModalDialog();
          }}
        >
          {orderState.actionDialog.modalType === 2
            ? "Import DPD orders"
            : orderState.actionDialog.modalType === 3
            ? "Import Evri Oders"
            : orderState.actionDialog.modalType === 4
            ? "Import DPD Manifested Orders"
            : "Reassign delivery partner"}
        </ModalHeader>

        <ModalBody>
          {orderState.actionDialog.modalType !== 0 &&
            (orderState.actionDialog.modalType === 2 || orderState.actionDialog.modalType === 3 || orderState.actionDialog.modalType === 4) && (
              <Form onSubmit={handleSubmit(onSubmitForm)}>
                <Row className="ml-2 mt-3">
                  <Col md={12}>
                    <DropZone extension={".csv"} onChangeFile={handleFileInputChange}></DropZone>
                    {/*<input type="file" name="file" onChange={handleFileInputChange}/>*/}
                  </Col>
                  {uploadFile ? <Typography>File: {`${uploadFile[0]?.name}`} </Typography> : ""}
                </Row>
                <Row>
                  <Col md={9}></Col>
                  <Col md={3} className="mt-3">
                    <button ref={submitBtnSaveRef} disabled={saveBtnLoad} className="btn btn-success btn-block">
                      {saveBtnLoad ? ( // Show the spinner if loading state is true
                        <i className="fa fa-spinner fa-spin fa-lg spinner mr-1" />
                      ) : (
                        "Import" // Show the regular text if loading state is false
                      )}
                    </button>
                  </Col>
                </Row>
                <Row>
                  {orderState.DpdManifestedError &&
                  Array.isArray(orderState.DpdManifestedError.errors) &&
                  orderState.DpdManifestedError.errors.length > 0 ? (
                    <>
                      <Col sm={12} style={{ color: "red", marginTop: "0.8rem" }}>
                        {orderState.DpdManifestedError.errors.length} Records could not be updated due to the following errors:
                      </Col>

                      <Col sm={12} style={{ color: "red", marginTop: "0.8rem" }}>
                        {formatErrorMessage(orderState.DpdManifestedError)}
                      </Col>
                    </>
                  ) : (
                    <>
                      {orderState.DpdManifestedError?.errors && typeof orderState.DpdManifestedError.errors === "string" && (
                        <Col sm={12} style={{ color: "red", marginTop: "0.8rem" }}>
                          {orderState.DpdManifestedError.errors}
                        </Col>
                      )}
                    </>
                  )}
                </Row>
              </Form>
            )}

          {orderState.actionDialog.modalType !== 0 && orderState.actionDialog.modalType === 1 && (
            <Form onSubmit={handleSubmit(onSubmitForm)}>
              <Row>
                <Col md={6}>
                  <Select
                    isDisabled={true}
                    value={orderState.currentDeliveryPartner}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    placeholder={<div>Delivery Partners </div>}
                    className="select2-filter border"
                    isClearable
                    cacheOptions
                    styles={customStyles}
                    options={orderState.settings.deliveryPartners}
                    onChange={(e) => {
                      setValue("deliveryPartner", e);

                      trigger("deliveryPartner");
                      // console.log(e)
                      // setDeliverPartner(e ? e.id : null)
                    }}
                  />
                </Col>
                <Col md={6}>
                  <Select
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    placeholder={<div>Delivery Partners </div>}
                    className="select2-filter border"
                    isClearable
                    cacheOptions
                    styles={customStyles}
                    options={orderState.currentDeliveryPartners}
                    onChange={(e) => {
                      setValue("deliveryPartner", e);

                      trigger("deliveryPartner");
                      // console.log(e)
                      // setDeliverPartner(e ? e.id : null)
                    }}
                  />
                </Col>
              </Row>
              {/*{!orderState.currentDeliveryPartner && <Col md={12}>*/}
              {/*    <Select*/}
              {/*        getOptionLabel={(option) => option.name}*/}
              {/*        getOptionValue={(option) => option.id}*/}
              {/*        placeholder={<div>Delivery Partners </div>}*/}
              {/*        className="select2-filter border"*/}
              {/*        isClearable*/}
              {/*        cacheOptions*/}
              {/*        styles={customStyles}*/}
              {/*        options={orderState.settings.deliveryPartners}*/}
              {/*        onChange={(e) => {*/}
              {/*            setValue('deliveryPartner', e);*/}

              {/*            trigger('deliveryPartner')*/}
              {/*            // console.log(e)*/}
              {/*            // setDeliverPartner(e ? e.id : null)*/}
              {/*        }}*/}

              {/*    />*/}
              {/*</Col>}*/}

              <Row>
                <Col md={9}></Col>
                <Col md={3} className="mt-3" style={{ float: "right" }}>
                  <button
                    ref={submitBtnSaveRef}
                    disabled={saveBtnLoad}
                    onClick={() => {
                      // setActionBtn(1)
                    }}
                    className="btn btn-success btn-block"
                  >
                    {saveBtnLoad ? ( // Show the spinner if loading state is true
                      <i className="fa fa-spinner fa-spin fa-lg spinner mr-1" />
                    ) : (
                      "Submit" // Show the regular text if loading state is false
                    )}
                  </button>
                </Col>
              </Row>
            </Form>
          )}
        </ModalBody>
        {orderState.actionDialog.modalType === 4 && (
          <ModalFooter className="mt-2">
            <a
              href="#"
              style={{ color: "black", fontWeight: "normal" }}
              onClick={(e) => {
                const url = `${baseUrlAsync}/order/download/dpd-manifested-orders-sample-csv`;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "");
                document.body.appendChild(link);
                link.click();
                link.remove();
              }}
            >
              <i className="fa fa-download mr-1" aria-hidden="true"></i>
              Download Sample CSV
            </a>
          </ModalFooter>
        )}
      </Modal>
    </div>
  );
}
